export type IWebVitals =
  | 'LCP'
  | 'FCP'
  | 'FID'
  | 'TTFB'
  | 'CLS'
  | 'INP'
  | 'DOMInteractive'
  | 'DOMContentLoaded'
  | 'DOMComplete'
  | 'Next.js-hydration'
  | 'Next.js-render'
  | 'Next.js-route-change-to-render';

export interface IPerformanceTrackingOptions {
  // eslint-disable-next-line camelcase
  previous_location?: string;
}

export enum WEB_VITAL_ATTRIBUTE_NAME {
  'DOMComplete' = 'dom_complete',
  'DOMContentLoaded' = 'dom_content_loaded',
  'DOMInteractive' = 'dom_interactive',
  'CLS' = 'cumulative_layout_shift',
  'FCP' = 'first_contentful_paint',
  'Next.js-hydration' = 'hydration',
  'TTFB' = 'time_to_first_byte',
  'FID' = 'first_input_delay',
  'INP' = 'interaction_to_next_paint',
  'LCP' = 'largest_contentful_paint',
  'Next.js-render' = 'render',
  'Next.js-route-change-to-render' = 'route_change_to_render',
}
